export default __webpack_public_path__ + "static/media/PVB.dd262fec.jpg";